/* eslint-disable object-curly-newline */
/* eslint-disable no-nested-ternary */
/* eslint-disable default-case */
import React from "react";

import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

import { CAREER_TYPE_ELEARNING, CAREER_TYPE_CLASSROOM } from "../../Constants";

interface GroupTagProps {
    children?: string;
    careerTypeId?: string | number;
    style?: { dotColor?: string; bgcolor: string; fontColor: string };
    dotDisplay?: string;
}

const ItemizeGroupTag = (props: GroupTagProps) => {
    const theme = useTheme();
    const { children, careerTypeId, style, dotDisplay } = props;
    const bgcolor = style?.dotColor ? style.dotColor : careerTypeId ? "#8999B3" : theme.palette.primary.main;
    let text = children;
    switch (String(careerTypeId)) {
        case CAREER_TYPE_ELEARNING:
            text = "eラーニング";
            break;

        case CAREER_TYPE_CLASSROOM:
            text = "集合研修";
            break;
    }

    const gridStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid",
        borderRadius: "20px ",
        paddingLeft: "0.25rem",
        paddingRight: "0.25rem",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem",
        fontSize: "13px",
        borderColor: "white",
        color: style?.fontColor ? style.fontColor : "#A0A0A0",
        backgroundColor: style?.bgcolor ? style.bgcolor : "white",
        padding: "0 8px",
    };

    return (
        text && (
            <div style={gridStyle}>
                {dotDisplay !== "none" && (
                    <div
                        style={{
                            width: "0.5rem",
                            minWidth: "0.5rem",
                            height: "0.5rem",
                            borderRadius: "50%",
                            background: bgcolor,
                            marginRight: "0.5rem",
                        }}
                    />
                )}
                <Typography sx={{ wordBreak: "break-all" }}>{text}</Typography>
            </div>
        )
    );
};

export default ItemizeGroupTag;
